export const OldDarkTheme = "#2c3c5b";
export const InputColor = "#E2E8F0";
export const DarkThemeLight = "#1b2537";

export const DarkerThemeOriginal = "#233048";
export const DarkTheme = "#273266";

export const SidemenuPurple = "#5800b2";
export const DarkerTheme = "#08133f";
export const LightTheme = "#E9F1F6";
export const DarkModeTheme = "#0d1117 ";

export const Blue600 = "#2B6CB0";
export const FadeBlue600 = "#AAC4DF";
export const Black = "#0D121B";
export const MainGreen = "#1DBA9E";
export const FadeMainGreen = "#A5E3D8";
export const MainGreenBlue = "#6DDDD0";
export const MainBlue = "#42A5FF";
export const MainYellow = "#FBDE37";
export const MainGrey = "#869CB8";
export const MainPink = "#F72585";
export const FadeMainPink = "#FCA8CE";
export const MainPurple = "#7F00FF";
export const DarkPurple = "#7209B7";
export const PurpleBlue = "#560BAD";
export const LightBlue = "#4169E1";
export const MainRed = "#C53030";
export const MainOrange = "#ff9248";
export const DarkGreen = "#56AEA6";
export const LightGreen = "#61FBCA";
export const White = "#fff";

export const LeafRed = "#bc4870";
export const LeafGreen1 = "#4ecf97";
export const LeafGreen2 = "#59b08b";
export const LeafGreen3 = "#569cac";
export const LeafGreen4 = "#4da89d";
export const Facebook = "#4267B2";
export const Twitter = "#1DA1F2";
export const Instagram = "#E1306C";
export const MailingGreen = "#A0C96D";
export const AchievementPink = "#EAABCB";
export const AchievementBrown = "#A9A59F";
export const AchievementPurple = "#9A90CC";
export const AchievementCyan = "#98D0DC";
export const AchievementGreen = "#8DCE9A";
export const AchievementOrange = "#E8B98D";

export const MailingOrange = "#FEB703";
export const MailingOrangeDarker = "#FD5C14";
export const MailingGreen1 = "#97B515";
export const MailingGreen2 = "#518401";
export const MailingGreen3 = "#DBF480";
export const MailingGreen4 = "#144814";

export const MailingPurple = "#9E72D7";
export const MailingBaloonOrange = "#FF7E66";
export const MailingBlue1 = "#4979FF";
export const MailingBlue2 = "#5DE9FF";
export const MailingYellow = "#FFCA5A";
export const MailingGrey = "#C7CDE7";
